import { forwardRef } from "react";
import { Spinner } from "./ui";

/**
 * 一覧の末尾に置く「続きを読む」領域。
 * ここが画面に入ると App 側の IntersectionObserver が自動で次を読む。
 * 自動読み込みが効かない環境でも押せるようにボタンも出す。
 */
export const LoadMore = forwardRef<
  HTMLDivElement,
  { hasMore: boolean; loading: boolean; onClick: () => void; doneLabel: string }
>(function LoadMore({ hasMore, loading, onClick, doneLabel }, ref) {
  return (
    <div ref={ref} className="flex justify-center py-6">
      {hasMore ? (
        <button type="button" onClick={onClick} disabled={loading} className="btn-soft">
          {loading ? <Spinner className="h-4 w-4" /> : null}
          {loading ? "読み込み中…" : "さらに読み込む"}
        </button>
      ) : (
        <span className="text-[12.5px] text-slate-400">{doneLabel}</span>
      )}
    </div>
  );
});
